import { Check, X } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const FOR_LIST = [
  "B2B service founders — agencies, consultants, IT and fractional firms.",
  "Average deal value of $5,000 or more.",
  "Able to give 2–3 hours during the sprint week.",
];

const NOT_FOR_LIST = [
  "Businesses selling low-ticket products.",
  "Founders looking for guaranteed revenue from a 7-day sprint.",
];

const WhoItsFor = () => (
  <section
    id="who-its-for"
    data-testid="who-its-for-section"
    className="scroll-mt-24 border-y border-line bg-white py-20 lg:py-28"
  >
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <Reveal>
        <Eyebrow>Who it's for</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 max-w-2xl font-serif text-3xl font-medium leading-[1.18] tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Built for a specific kind of founder.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 lg:grid-cols-5">
        <Reveal className="h-full lg:col-span-3">
          <div
            data-testid="for-list"
            className="h-full rounded-3xl bg-moss p-8 text-cream sm:p-12"
          >
            <h3 className="font-serif text-2xl sm:text-3xl">The sprint works for you if…</h3>
            <ul className="mt-10 space-y-6">
              {FOR_LIST.map((item) => (
                <li key={item} className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-cream/10">
                    <Check className="h-4 w-4 text-gold" />
                  </span>
                  <span className="text-base leading-relaxed text-cream/90 sm:text-lg">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="h-full lg:col-span-2">
          <div
            data-testid="not-for-list"
            className="h-full rounded-3xl border border-line bg-cream p-8 sm:p-12"
          >
            <h3 className="font-serif text-2xl text-ink sm:text-3xl">It's not for you if…</h3>
            <ul className="mt-10 space-y-6">
              {NOT_FOR_LIST.map((item) => (
                <li key={item} className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-line bg-white">
                    <X className="h-4 w-4 text-smoke" />
                  </span>
                  <span className="text-base leading-relaxed text-smoke sm:text-lg">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
            <p className="mt-10 border-t border-line pt-6 font-mono text-[11px] uppercase leading-relaxed tracking-[0.16em] text-smokeLight">
              Honest fit beats a full calendar
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default WhoItsFor;
